import React from 'react';
import { Button } from 'baseui/button';
import { Select } from 'baseui/select';
import { PlayIcon } from '../../styles/iconStyles';
import {
  ModalContentWrapper,
  SettingsSectionContainer,
  SettingsRow,
  SettingsHeading,
  StretchedSettingsInputGroup,
  iconSizes,
} from '../../styles/displaySettingsModalStyles';

const TtsSettingsTab = ({ settings, actions, t, palette }) => {
  const { handleSettingChange } = actions;
  const { provider, voice } = settings.tts;

  const providers = [
    { label: 'Web Speech API (標準)', id: 'web-speech' },
    { label: 'Azure AI Speech', id: 'azure' },
  ];

  const allVoices = [
    { label: '--- 日本語 (Japanese) ---', id: 'header-ja', disabled: true },
    { label: 'ナナミ (標準/女性)', id: 'ja-JP-NanamiNeural', lang: 'ja-JP' },
    { label: 'ケイタ (標準/男性)', id: 'ja-JP-KeitaNeural', lang: 'ja-JP' },
    { label: 'アオイ (女性)', id: 'ja-JP-AoiNeural', lang: 'ja-JP' },
    { label: 'ダイチ (男性)', id: 'ja-JP-DaichiNeural', lang: 'ja-JP' },
    { label: 'マユ (女性)', id: 'ja-JP-MayuNeural', lang: 'ja-JP' },
    { label: 'シオリ (女性)', id: 'ja-JP-ShioriNeural', lang: 'ja-JP' },
    { label: 'ナオキ (男性)', id: 'ja-JP-NaokiNeural', lang: 'ja-JP' },
    { label: '--- 英語 (English) ---', id: 'header-en', disabled: true },
    { label: 'Jenny (Female)', id: 'en-US-JennyNeural', lang: 'en-US' },
    { label: 'Guy (Male)', id: 'en-US-GuyNeural', lang: 'en-US' },
    { label: 'Aria (Female)', id: 'en-US-AriaNeural', lang: 'en-US' },
    { label: 'Davis (Male)', id: 'en-US-DavisNeural', lang: 'en-US' },
    { label: 'Amber (Female)', id: 'en-US-AmberNeural', lang: 'en-US' },
    { label: 'Andrew (Male)', id: 'en-US-AndrewNeural', lang: 'en-US' },
  ];

  const handlePlaySample = () => {
    const selectedVoice = allVoices.find(v => v.id === voice);
    if (!selectedVoice) return;

    const sampleText = selectedVoice.lang === 'ja-JP'
      ? 'こんにちは。私の声はいかがですか？'
      : 'Hello. How do you like my voice?';

    // speak action を直接呼び出す
    actions.speak(sampleText, null, null, true);
  };

  return (
    <ModalContentWrapper>
      <SettingsSectionContainer>
        <SettingsHeading $palette={palette}>{t('display.ttsProviderLabel') || '音声合成エンジン'}</SettingsHeading>
        <SettingsRow>
          <Select
            options={providers}
            value={providers.filter(p => p.id === provider)}
            onChange={params => handleSettingChange('tts', 'provider', params.value[0].id)}
            labelKey="label"
            valueKey="id"
            clearable={false}
          />
        </SettingsRow>
      </SettingsSectionContainer>
      <SettingsSectionContainer>
        <SettingsHeading $palette={palette}>{t('display.ttsVoiceLabel') || '音声キャラクター'}</SettingsHeading>
        <SettingsRow>
          <StretchedSettingsInputGroup>
            <Select
              options={allVoices}
              value={allVoices.filter(v => v.id === voice)}
              onChange={params => handleSettingChange('tts', 'voice', params.value[0].id)}
              labelKey="label"
              valueKey="id"
              clearable={false}
              disabled={provider !== 'azure'}
            />
            <Button
              size="compact"
              shape="circle"
              title={t('display.testCharacterVoiceTooltip') || 'キャラクターの声をテスト'}
              onClick={handlePlaySample}
              disabled={provider !== 'azure'}
            >
              <PlayIcon $size={iconSizes.ACTION} />
            </Button>
          </StretchedSettingsInputGroup>
        </SettingsRow>
      </SettingsSectionContainer>
    </ModalContentWrapper>
  );
};

export default TtsSettingsTab;
